module.exports = __webpack_public_path__ + "img/qrcode.9248c883.jpg";